import { debounce } from "@/utils";

export default function (refValue) {
  return {
    data() {
      return {
        // 存储滚动容器DOM和防抖函数，避免重复创建/获取
        scrollContainer: null,
        setMoreDebounce: null
      };
    },
    mounted() {
      // 1. 等待DOM渲染完成后再获取ref，避免初始为undefined
      this.$nextTick(() => {
        this.scrollContainer = this.$refs[refValue];

        // 2. 只有容器存在时才添加监听，防止报错
        if (this.scrollContainer) {
          this.setMoreDebounce = debounce(this.handleMainScroll, 50);
          this.scrollContainer.addEventListener("scroll", this.setMoreDebounce);
        }

        // 3. 保留原有bus事件监听（不影响其他功能）
        this.$bus.$on("setMainScroll", this.handleSetMainScroll);
        this.$bus.$on("setMainBottomScroll", this.handleSetMainBottomScroll);
      });
    },
    beforeUnmount() {
      // 1. 容错：容器不存在时直接返回，避免removeEventListener报错
      if (this.scrollContainer && this.setMoreDebounce) {
        this.scrollContainer.removeEventListener("scroll", this.setMoreDebounce);
      }

      // 2. 保留原有bus事件触发
      this.$bus.$emit("mainScroll");

      // 3. 移除bus事件监听（修复原代码中off/on混用的bug）
      this.$bus.$off("setMainScroll", this.handleSetMainScroll);
      this.$bus.$off("setMainBottomScroll", this.handleSetMainBottomScroll);

      // 4. 清空变量，避免内存泄漏
      this.scrollContainer = null;
      this.setMoreDebounce = null;
    },
    methods: {
      handleMainScroll() {
        // 容错：容器不存在时不触发事件
        if (this.scrollContainer) {
          this.$bus.$emit("mainScroll", this.scrollContainer);
        }
      },
      handleSetMainScroll(scrollTop) {
        // 容错：容器不存在时不执行滚动操作
        if (this.scrollContainer) {
          this.scrollContainer.scrollTop = scrollTop;
        }
      },
      handleSetMainBottomScroll() {
        // 容错：容器不存在时不执行滚动操作
        if (this.scrollContainer) {
          this.scrollContainer.scrollTop = this.scrollContainer.scrollHeight;
        }
      }
    },
  }
}